import { AboutUs } from './AboutUs';
import { CarPark } from './CarPark';
import { FAQ } from './FAQ';
import { Hero } from './Hero';
import { HowItWorks } from './HowItWorks';
import { PerfectTransfer } from './PerfectTransfer';
import { WhyWe } from './WhyWe';
import { FormAndReviews } from './FormAndReviews';

export function Home() {
  return (
    <div>
      <Hero />
      <CarPark />
      <AboutUs />
      <WhyWe />
      <PerfectTransfer />
      <HowItWorks />
      <FAQ />
      <FormAndReviews />
    </div>
  );
}
